import TAXApi from './_taxApi';
import httpClient from '@/apis/base/httpclient';
class TARiskCustomerVendorAPI extends TAXApi {
  constructor() {
    super();
  }
  controllerName = 'TARiskCustomerVendors';
  /**
   * Lấy danh sách KH, NCC rủi ro
   * TPNAM 28.12.2022
   */
  async getRiskCustomers() {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetRiskCustomers'
    };

    return await httpClient.getAsync(request);
  }
  /** 
   * Lấy dữ liệu hóa đơn
   * TPNAM 17.01.2024
   */
  async getDataInvoice(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetDataInvoice',
      data: param,
    };
    return await httpClient.postAsync(request);
  }
}

export default new TARiskCustomerVendorAPI();
